import { BaseSizeEnum as e } from "./common.js";
const o = {
  [e.Small]: 16,
  [e.Medium]: 22,
  [e.Large]: 28
};
export {
  o as SIZE_MAP
};
//# sourceMappingURL=coin.js.map
